import * as constants from './constants'

const INITIAL_STATE = {
  loading: false,
  saveLoading: false,
  supporter: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  vip: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  supporterResponse: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {}
  },
  vipResponse: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {}
  },
  resendTicketResponse: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {}
  },
  soldTicket: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return Object.assign({}, state, {
        loading: action.data
      })
    case constants.SET_SAVE_LOADING:
      return Object.assign({}, state, {
        saveLoading: action.data
      })
    case constants.SET_SUPPORTER:
      return Object.assign({}, state, {
        supporter: action.data
      })
    case constants.SET_VIP:
      return Object.assign({}, state, {
        vip: action.data
      })
    case constants.SET_SUPPORTER_RESPONSE:
      return Object.assign({}, state, {
        supporterResponse: action.data
      })
    case constants.SET_VIP_RESPONSE:
      return Object.assign({}, state, {
        vipResponse: action.data
      })
    case constants.SET_SOLD_TICKET:
      return Object.assign({}, state, {
        soldTicket: action.data
      })
    case constants.SET_RESEND_TICKET:
      return Object.assign({}, state, {
        resendTicketResponse: action.data
      })
    default: return state
  }
}
